module.exports = __webpack_public_path__ + "img/comments.c67b7ab9.png";